import { mdiMenuDown, mdiMenuRight } from '@mdi/js';
import { MultiSelectTreeViewProps, SimpleTreeView } from '@mui/x-tree-view';
import React from 'react';
import IconWrapper from '../Icons/IconWrapper';

/**
 * Customisable TreeView component.
 */
export default (props: DynamicTreeProps) => {
    const { style, ...otherProps } = props;
    const treeViewProps: MultiSelectTreeViewProps = {
        ...(otherProps as MultiSelectTreeViewProps),
        defaultExpandedItems: ['root'],
        slots: {
            expandIcon: IconWrapper({ path: mdiMenuRight }),
            collapseIcon: IconWrapper({ path: mdiMenuDown }),
        },
        sx: {
            overflowX: 'hidden',
            flexGrow: 4,

            '& .MuiTreeItem-content': {
                gap: 0,
            },
            ...style,
        },
        multiSelect: true,
    };

    return <SimpleTreeView {...treeViewProps} />;
};

/**
 * Type that limits the MultiSelectTreeViewProps interface down to those properties that are needed fo the DynamicTree component.
 */
export type DynamicTreeProps = Pick<
    MultiSelectTreeViewProps,
    | 'onExpandedItemsChange'
    | 'onItemExpansionToggle'
    | 'onSelectedItemsChange'
    | 'expandedItems'
    | 'selectedItems'
    | 'style'
    | 'children'
>;
